import fe_config from "constants/Configs";
import { UserManager } from "oidc-client-ts";
import { ssoTabSync } from "./ssoTabSync";

export const PING_SCOPE =
  "phone profile email openid account-statement accounting-system-core-data accountingdocument address adp-service amount-type api-tokens audit-service bank-status batch bi-integration bot-service business-partner cashflow cashflow-reader communication-channel conditions configuration-pump credit-collection experiencebuilder feature-management file-importer file-interface file-service fine-filter gdpr-personal-data insight key-service masterdata mobile-app monitoring-service notification object-factory offline_access open-item-core-data open-item-import origin-core-data payment-condition payment-format policy-service posting-rule processing-functions-executor processing-profile-executor profile-manager replacement restrictions rule-engine settings-configuration-service sftp-service statement-service tenant-service tenant-service-frontend tolerance-group user-manager validatorservice";

export const OIDC_PROVIDER = {
  PLATFORM: "platform",
  INTEGRATION: "integration",
};

export const OIDC_PROVIDER_STORAGE_KEY = "oidcProvider";

export const OidcConfig = {
  authority: fe_config.PING_WELL_KNOWN,
  client_id: fe_config.PING_CLIENT_ID,
  client_secret: fe_config.PING_CLIENT_SECRET,
  redirect_uri: fe_config.PING_REDIRECT_URI,
  post_logout_redirect_uri: fe_config.PING_REDIRECT_URI,
  scope: PING_SCOPE,
  // Renewal is triggered manually by ssoTabSync (leader tab only) to avoid
  // every open tab racing Ping's refresh-token rotation.
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTimeInSeconds: 360,
};

export const IntegrationOidcConfig = {
  ...OidcConfig,
  authority: fe_config.PING_INTEGRATION_WELL_KNOWN,
  client_id: fe_config.PING_INTEGRATION_CLIENT_ID,
  client_secret: fe_config.PING_INTEGRATION_CLIENT_SECRET,
};

export const userManager = new UserManager(OidcConfig);
let integrationUserManager;

export const resolveOidcProviderFromHomeLink = (homeLink = "") => {
  if (fe_config.MODE !== "DEV") {
    return OIDC_PROVIDER.PLATFORM;
  }

  try {
    const { hostname } = new URL(homeLink);
    return hostname.includes("integration.serrala")
      ? OIDC_PROVIDER.INTEGRATION
      : OIDC_PROVIDER.PLATFORM;
  } catch (error) {
    return OIDC_PROVIDER.PLATFORM;
  }
};

export const setActiveOidcProviderFromHomeLink = (homeLink = "") => {
  const provider = resolveOidcProviderFromHomeLink(homeLink);
  localStorage.setItem(OIDC_PROVIDER_STORAGE_KEY, provider);
  return provider;
};

export const clearActiveOidcProvider = () => {
  localStorage.removeItem(OIDC_PROVIDER_STORAGE_KEY);
};

export const getActiveOidcProvider = () =>
  localStorage.getItem(OIDC_PROVIDER_STORAGE_KEY) || OIDC_PROVIDER.PLATFORM;

export const getIntegrationUserManager = () => {
  if (!integrationUserManager) {
    integrationUserManager = new UserManager(IntegrationOidcConfig);
  }

  return integrationUserManager;
};

export const getActiveUserManager = () =>
  getActiveOidcProvider() === OIDC_PROVIDER.INTEGRATION
    ? getIntegrationUserManager()
    : userManager;

ssoTabSync.start(getActiveUserManager());
